"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.SummaryPhoneNumberInput = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var React = require("react");
var commonFunctions_1 = require("../../commonFunctions");
var SummaryPhoneNumberInput = /** @class */ (function (_super) {
    __extends(SummaryPhoneNumberInput, _super);
    function SummaryPhoneNumberInput(props) {
        var _this = _super.call(this, props) || this;
        var phoneNumber = _this.props.phoneNumber;
        var phoneNumberValid = (0, commonFunctions_1.validatePhoneNumber)(phoneNumber);
        _this.state = {
            phoneNumber: phoneNumber,
            canEdit: _this.props.canEdit,
            phoneNumberValid: phoneNumberValid,
            showInputField: !phoneNumberValid
        };
        _this.handlePhoneNumberChange = _this.handlePhoneNumberChange.bind(_this);
        return _this;
    }
    SummaryPhoneNumberInput.prototype.render = function () {
        var _this = this;
        return ((0, jsx_runtime_1.jsxs)("div", { className: "detail mobile-number ".concat(this.state.showInputField ? "phone-input" : ""), children: [this.state.phoneNumberValid && !this.state.showInputField &&
                    (0, jsx_runtime_1.jsxs)("div", { className: "detail-key d-flex flex-column", children: [(0, jsx_runtime_1.jsxs)("p", { className: "mb-0", children: [(0, jsx_runtime_1.jsx)("span", { className: "font-weight-bold", children: "Phone number:" }), " ", this.props.phoneNumber] }), this.state.canEdit &&
                                (0, jsx_runtime_1.jsx)("button", { className: "btn-text edit-phone-button", onClick: function (e) { return _this.togglePhoneEditPopup(e); }, onKeyDown: function (e) { return _this.togglePhoneEditPopup(e); }, children: "Edit" })] }), (!this.state.phoneNumberValid || this.state.showInputField) &&
                    (0, jsx_runtime_1.jsxs)("div", { className: "detail-value form-group pt-0 mb-0", children: [this.state.showInputField &&
                                (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("label", { htmlFor: "phoneNumberInput", children: "Phone number:" }), (0, jsx_runtime_1.jsx)("div", { className: "input-group mb-0", children: (0, jsx_runtime_1.jsx)("input", { id: "phoneNumberInput", onChange: this.handlePhoneNumberChange, placeholder: "07XXXXXXX", type: "text", className: "form-control", value: this.state.phoneNumber }) })] }), !this.state.phoneNumberValid &&
                                (0, jsx_runtime_1.jsx)("div", { className: "invalid-feedback d-block", children: "That mobile number doesn\u2019t look right... Please check and try again" })] })] }));
    };
    SummaryPhoneNumberInput.prototype.togglePhoneEditPopup = function (event) {
        event.preventDefault();
        if (this.props.setJourneyState && this.props.canEdit) {
            this.props.setJourneyState({
                showPhoneNumberPopup: true
            });
        }
    };
    SummaryPhoneNumberInput.prototype.handlePhoneNumberChange = function (event) {
        var _this = this;
        event.preventDefault();
        var phoneNumber = event.target.value;
        this.setState({
            phoneNumber: phoneNumber,
            phoneNumberValid: (0, commonFunctions_1.validatePhoneNumber)(phoneNumber)
        }, function () { return _this.props.onStateChange("policyHolder.phoneNumber", phoneNumber); });
    };
    ;
    return SummaryPhoneNumberInput;
}(React.Component));
exports.SummaryPhoneNumberInput = SummaryPhoneNumberInput;
//# sourceMappingURL=SummaryPhoneNumberInput.js.map